import * as React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieConsent from "react-cookie-consent";
import { Link } from "gatsby";

interface LayoutProps {
  pageTitle?: string;
  className?: string;
  children: React.ReactNode;
}

const Layout = ({ pageTitle, className, children }: LayoutProps) => {
  return (
    <>
      <Header />
      <main className={className ?? "flex-grow flex mt-[64px]"}>
        {children}
      </main>
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        enableDeclineButton
        style={{ background: "black", alignItems: "center", padding: "10px 0", zIndex: 1000, justifyContent: "center" }}
        customButtonWrapperAttributes={{ style: { display:"flex", flexDirection:"column-reverse"} }	}
        declineButtonStyle={{ minWidth: '100px',borderRadius: "0.5rem",color: "black",backgroundColor:"#2F9CAB", fontSize: "13px", margin:"6px" }}
        buttonStyle={{ minWidth: '100px',borderRadius: "0.5rem",color: "black",backgroundColor:"#2F9CAB", fontSize: "13px", margin:"6px" }}
        cookieName="gatsby-gdpr-google-tagmanager"
      >
        We use cookies to enhance your browsing experience, serve personalized
        ads or content, and analyze our traffic. By clicking “Accept”, you
        consent to use our cookies. You can learn more in our <Link className="text-secondary underline" to={'/privacy-policy'} >privacy policy</Link>
      </CookieConsent>
      <Footer />
    </>
  );
};

export default Layout;
